import { render, staticRenderFns } from "./statisticsHardcoding.vue?vue&type=template&id=3fa872da"
import script from "./statisticsHardcoding.vue?vue&type=script&lang=js"
export * from "./statisticsHardcoding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fa872da')) {
      api.createRecord('3fa872da', component.options)
    } else {
      api.reload('3fa872da', component.options)
    }
    module.hot.accept("./statisticsHardcoding.vue?vue&type=template&id=3fa872da", function () {
      api.rerender('3fa872da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/status/statisticsHardcoding.vue"
export default component.exports